import {
  Box,
  Button,
  Center,
  Flex,
  HStack,
  IconButton,
  Link,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Portal,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useBreakpointValue,
  useDisclosure,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { Chart } from "react-google-charts";
import { BsThreeDotsVertical } from "react-icons/bs";
import { RiEyeLine } from "react-icons/ri";
import { NumericFormat } from "react-number-format";
import { useNavigate } from "react-router-dom";
import {
  Bar,
  BarChart,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import AdminDashboardHeader from "../../../components/admin/AdminHeader";
import AdminSidebar from "../../../components/admin/AdminSidebar";
import { NewSponsorModal } from "../../../components/admin/sponsor/newSponsorModal";
import Loading from "../../../components/common/Loading";
import {
  IGetSponsors,
  ISponsorAnalytics,
} from "../../../models/admin/sponsors.model";
import SponsorService from "../../../services/admin/sponsors.service";
import ExportExcel from "../../../utils/ExportExcel";
import Adminroutes from "../routes";

export const options = {
  title: "Sponsors Ratio",
};
export const ExcelDataExport = [
  {
    "S/N": "1",
    "Organization Name": "Naptin",
    "Organization Type": "Public/Private/Individual",
    Address: "....",
    Phone: "080.....",
    Email: "a@gmail.com",
    Website: "naptin.gov.ng",
  },
];

const SponsorDashboard = () => {
  const [isSponsor, setIsSponsor] = useState(false);

  const navigate = useNavigate();
  const [sponsors, setSponsors] = useState<IGetSponsors[]>();
  const [loading, setLoading] = useState(true);
  const [piechart, setPiechart] = useState<any[]>();
  const [reload, setReload] = useState(false);
  const [isBatch, setIsBatch] = useState<boolean>();
  const [sponsorsAnalytics, setSponsorsAnalytics] =
    useState<ISponsorAnalytics>();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const isMobile = useBreakpointValue({
    base: true,
    sm: true,
    md: false,
    lg: false,
  });

  const newSponsorModal = async (batch: boolean) => {
    setIsBatch(batch);
    setIsSponsor(true);
    onOpen();
  };

  useEffect(() => {
    SponsorService.getSponsorAnalytics()
      .then((res) => {
        const response: ISponsorAnalytics = res.data;
        setSponsorsAnalytics(res.data);
        const piechartContent: any[] = [];
        response.sponsors_count_by_category.forEach((count) => {
          piechartContent.push([count.type, count.count]);
        });
        const dataa = [["Sponsor", "Trainees"], ...piechartContent];
        setPiechart(dataa);
      })
      .catch((err) => err);
    const url = `?page=1`;
    SponsorService.getSponsors(url)
      .then((res) => {
        setSponsors(res.data);
       
      })
      .catch((err) => err).finally(() =>  setLoading(false));
  }, [reload]);

  const reloadData = () => {
    setReload(!reload);
  };
  const data = [
    {
      name: "Jan",
      revenue: 4000,
      profit: 2400,
      amt: 2400,
    },
    {
      name: "Feb",
      revenue: 3000,
      profit: 1398,
      amt: 2210,
    },
    {
      name: "Mar",
      revenue: 2000,
      profit: 9800,
      amt: 2290,
    },
    {
      name: "Apr",
      revenue: 2780,
      profit: 3908,
      amt: 2000,
    },
    {
      name: "May",
      revenue: 1890,
      profit: 4800,
      amt: 2181,
    },
    {
      name: "Jun",
      revenue: 2390,
      profit: 3800,
      amt: 2500,
    },
    {
      name: "Jul",
      revenue: 3490,
      profit: 4300,
      amt: 2100,
    },
    {
      name: "Aug",
      revenue: 2000,
      profit: 9800,
    },
    {
      name: "Sep",
      revenue: 2780,
      profit: 3908,
    },
    {
      name: "Oct",
      revenue: 1890,
      profit: 4800,
    },
    {
      name: "Nov",
      revenue: 2390,
      profit: 3800,
    },
    {
      name: "Dec",
      revenue: 3490,
      profit: 4300,
    },
  ];
  const viewSponsor = async (sponsor_id: string) => {
    navigate(Adminroutes.sponsor.EachSponsorLink(sponsor_id));
  };

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <Flex
          minHeight={"100vh"}
          height={"auto"}
          boxSizing="border-box"
          maxWidth={"100hw"}
        >
          <Box
            width={["3.5rem", "3.5rem", "3.5rem", "20%"]}
            position="relative"
            top="0"
            left="0"
            zIndex="100"
          >
            <AdminSidebar />
          </Box>

          <Box width="100%">
            <AdminDashboardHeader />
            <Box
              pt="30px"
              px={["20px", "30px"]}
              width={"100%"}
              bg="#F9F8F8"
              height={"auto"}
              minHeight={"95vh"}
              maxHeight={"95vh"}
              overflowX={"scroll"}
              className="scroll-hidden"
            >
              <Flex
                justifyContent="space-between"
                alignItems="center"
                pb="26px"
              >
                <Box color="#2B2B2B" fontWeight="800" fontSize="27px">
                  Sponsors Dashboard
                </Box>
                <Flex gap={3}>
                  {!isMobile && (
                    <>
                      <Button
                        py="7px"
                        px="10px"
                        onClick={() => {
                          newSponsorModal(false);
                        }}
                        fontSize={12}
                        borderRadius={2}
                        colorScheme="red"
                        size="sm"
                      >
                        New Sponsor
                      </Button>
                      <Button
                        borderRadius={2}
                        colorScheme="red"
                        size="sm"
                        fontSize={12}
                        onClick={() => {
                          newSponsorModal(true);
                        }}
                      >
                        Upload Sponsors
                      </Button>
                    </>
                  )}

                  <ExportExcel
                    title="Download Template"
                    excelData={ExcelDataExport}
                    fileName={"Sponsor Batch Template"}
                  />
                  {isMobile && (
                    <Menu>
                      <MenuButton
                        as={IconButton}
                        aria-label="Options"
                        icon={<BsThreeDotsVertical />}
                        variant="outline"
                        bg="white"
                        height={"32px"}
                        borderRadius={"2px"}
                        _hover={{ bg: "gray.100" }}
                        _active={{ bg: "gray.200" }}
                      />
                      <MenuList fontSize={12}>
                        <MenuItem
                          onClick={() => {
                            newSponsorModal(false);
                          }}
                        >
                          New Sponsor
                        </MenuItem>
                        <MenuItem
                          onClick={() => {
                            newSponsorModal(true);
                          }}
                        >
                          Upload Sponsors
                        </MenuItem>
                      </MenuList>
                    </Menu>
                  )}
                </Flex>
              </Flex>

              <Flex
                justifyContent="space-between"
                mb="30px"
                flexDirection={["column", "column", "column", "row"]}
                gap="1rem"
              >
                <Box
                  width={["100%", "100%", "100%", "30%"]}
                  p={["20px", "20px", "40px", "40px"]}
                  boxShadow={"sm"}
                  bg="white"
                >
                  <Flex width="100%">
                    <Box
                      borderRight="2px solid"
                      width="50%"
                      pr="25px"
                      pb="25px"
                      borderColor="lightgray"
                    >
                      <Text fontSize="14px" mb="10px" color="#959595">
                        Total Balance
                      </Text>
                      <Text fontWeight="700" fontSize="14px" color="#616161">
                        <NumericFormat
                          value={sponsorsAnalytics?.total_sponsor_budget}
                          displayType={"text"}
                          thousandSeparator={true}
                          prefix={"₦"}
                        />
                      </Text>
                    </Box>
                    <Box
                      borderBottom="2px solid"
                      width="50%"
                      pl="25px"
                      pb="25px"
                      borderColor="lightgray"
                    >
                      <Text fontSize="14px" mb="10px" color="#959595">
                        Total Revenue
                      </Text>
                      <Text fontWeight="700" fontSize="14px" color="#616161">
                        <NumericFormat
                          value={sponsorsAnalytics?.total_sponsor_budget_paid}
                          displayType={"text"}
                          thousandSeparator={true}
                          prefix={"₦"}
                        />
                      </Text>
                    </Box>
                  </Flex>

                  <Flex width="100%">
                    <Box
                      borderTop="2px solid"
                      width="50%"
                      pr="25px"
                      pb="25px"
                      borderColor="lightgray"
                    >
                      <Text fontSize="14px" mb="10px" pt="25px" color="#959595">
                        Total Sponsors
                      </Text>
                      <Text fontWeight="700" fontSize="34px" color="#616161">
                        {sponsorsAnalytics?.total_sponsors
                          ? sponsorsAnalytics.total_sponsors
                          : "0"}
                      </Text>
                    </Box>
                    <Box
                      borderLeft="2px solid"
                      width="50%"
                      pl="25px"
                      pb="25px"
                      borderColor="lightgray"
                    >
                      <Text fontSize="14px" mb="10px" pt="25px" color="#959595">
                        Total Sponsored Trainees
                      </Text>
                      <Text fontWeight="700" fontSize="34px" color="#616161">
                        {sponsorsAnalytics?.total_sponsored_trainees
                          ? sponsorsAnalytics.total_sponsored_trainees
                          : "0"}
                      </Text>
                    </Box>
                  </Flex>
                </Box>

                <Box
                  width={["100%", "100%", "100%", "70%"]}
                  padding="20px"
                  boxShadow={"sm"}
                  bg="white"
                >
                  <Box height="250px" width="100%">
                    <ResponsiveContainer width="100%" height="100%">
                      <BarChart
                        width={500}
                        height={300}
                        data={data}
                        margin={{
                          top: 5,
                          right: 30,
                          left: 20,
                          bottom: 5,
                        }}
                      >
                        <XAxis dataKey="name" />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        <Bar dataKey="revenue" fill="#EC3337" />
                        <Bar dataKey="profit" fill="#F79E1B" />
                      </BarChart>
                    </ResponsiveContainer>
                  </Box>
                </Box>
              </Flex>

              <Flex
                mb="30px"
                justifyContent="space-between"
                gap="1rem"
                flexDirection={["column", "column", "column", "row"]}
              >
                <Box
                  width={["100%", "100%", "100%", "65%"]}
                  height="300px"
                  bg="white"
                  p="15px"
                  boxShadow={"sm"}
                >
                  <Flex
                    bg="white"
                    pb="12px"
                    pt="15px"
                    mb="36px"
                    justifyContent="space-between"
                  >
                    <Text fontSize="18px" fontWeight="500">
                      Sponsors
                    </Text>
                    <Link
                      fontWeight="500"
                      color="#EC3337"
                      fontSize="16px"
                      onClick={() => {
                        navigate(Adminroutes.sponsor.SponsorList);
                      }}
                    >
                      See All
                    </Link>
                  </Flex>
                  <TableContainer>
                    <Table variant="simple" size="sm">
                      <Thead mb="10px">
                        <Tr
                          pb="10px"
                          fontSize="14px"
                          borderBottom="1px solid"
                          borderColor="#D5D5D5"
                        >
                          <Th textTransform="none">Sponsors</Th>
                          <Th textTransform="none">Sponsors ID</Th>
                          <Th textTransform="none">Trainees</Th>
                          <Th textTransform="none">Amount</Th>
                          <Th textTransform="none">Status</Th>
                          <Th textTransform="none">Options</Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {!loading ? (sponsors && sponsors?.length > 0 ? (
                          sponsors.slice(0, 3).map((each, index) => (
                            <Tr key={index} bg="white" fontSize="14px">
                              <Td>
                                <Text textTransform="capitalize">
                                  {each.organization_name.toLowerCase()}
                                </Text>
                              </Td>
                              <Td>
                                {" "}
                                <Text>{each.code}</Text>
                              </Td>
                              <Td>
                                {" "}
                                <Text>0</Text>
                              </Td>
                              <Td>
                                <Text>0.00</Text>
                              </Td>
                              <Td>
                                {each.status == 1 ? (
                                  <Text>In Progress</Text>
                                ) : (
                                  <Text>Suspended</Text>
                                )}
                              </Td>
                              <Td>
                                <HStack>
                                  <Center
                                    border="1px solid"
                                    borderRadius="10px"
                                    onClick={() => {
                                      viewSponsor(each.uuid);
                                    }}
                                    borderColor="#E5E5E5"
                                    width="30px"
                                    height="30px"
                                  >
                                    <RiEyeLine />
                                  </Center>
                                </HStack>
                              </Td>
                            </Tr>
                          ))
                        ) : (
                          <div>no sponsors yet, create a sponsor</div>
                        )) : ""}
                      </Tbody>
                    </Table>
                  </TableContainer>
                </Box>
                <Box width={["100%", "100%", "100%", "35%"]} boxShadow={"sm"}>
                  <Chart
                    chartType="PieChart"
                    data={piechart}
                    options={options}
                    width={"100%"}
                    height={"300px"}
                  />
                </Box>
              </Flex>
            </Box>
          </Box>
          {isSponsor && (
            <Portal>
              {" "}
              <NewSponsorModal
                isOpen={isOpen}
                onClosed={onClose}
                isSponsor={isSponsor}
                reload={reloadData}
                isBatch={isBatch}
              />{" "}
            </Portal>
          )}
        </Flex>
      )}
    </>
  );
};

export default SponsorDashboard;
